import { center } from '@repo/themes/styled-system/patterns';

const LoadingSpinner = () => (
  <div className={center({ w: 'full', minH: '[80dvh]' })}>
    <svg
      width='300'
      height='300'
      viewBox='0 0 50 50'
      xmlns='http://www.w3.org/2000/svg'
    >
      <style>
        {`
        .spinner {
          transform-origin: center;
          animation: rotate 0.75s linear infinite;
        }
        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
      `}
      </style>
      <circle
        className='spinner'
        cx='25'
        cy='25'
        r='20'
        fill='none'
        stroke='#000'
        strokeWidth='1'
        strokeLinecap='round'
        strokeDasharray='31.4 62.8'
      />
    </svg>
  </div>
);

export default LoadingSpinner;
